import { ListGroup, Badge } from "react-bootstrap";
import { FaCheckDouble, FaRegFileAlt, FaBell, FaHeadset, FaFileSignature, FaCalendarAlt, FaFileContract, FaMoneyCheck, FaMoneyBill, FaEdit, FaCoins, FaFileMedical, FaUserAlt, FaUserFriends, FaRegEye, FaRegIdCard, FaPills, FaNotesMedical, FaMedkit, FaRenren, FaBox, FaRegHandshake, FaBoxes, FaUserInjured, FaUserMd, FaWallet, FaPenSquare, FaEnvelope, FaCreditCard, FaBriefcaseMedical, FaDisease, FaStethoscope, FaChartBar, FaFileMedicalAlt, FaBookOpen, FaDollarSign, FaHome, FaFile, FaTeamspeak, FaFileImport } from "react-icons/fa";
import { TbTicket } from "react-icons/tb";
import { hasPerm, getCurrentUser } from "../../common/utils";
import PropTypes from 'prop-types';

const Menu = ({ pathname, faturamentosPendentes }) => {

    const dados_usuario = getCurrentUser();

  return (
    <>
        {dados_usuario.is_superuser && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/home" className="itemMenu" active={pathname.indexOf("/home") !== -1 || pathname === "/"} >
                    <FaHome /> Home
                </ListGroup.Item>
            </ListGroup>
        )}

        {hasPerm("view_agendamentos") && (
            <>
                <div className="list-divider"> <p>Atendimento ao Paciente</p> </div>

                {hasPerm("view_agendamentos") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/agendamentos" className="itemMenu" active={pathname.indexOf("/agendamentos") !== -1} >
                            <FaCalendarAlt /> Agendamentos
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_atendimentos") && (
                    <>
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/atendimentos" className="itemMenu" active={pathname === "/atendimentos" || pathname === "/atendimentos/"}>
                            <FaHeadset /> Atendimentos
                        </ListGroup.Item>
                    </ListGroup>
                    </>
                )}

                {hasPerm("view_autorizacoes") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/autorizacoes" className="itemMenu" active={pathname.indexOf("/autorizacoes") !== -1} >
                            <FaFileContract /> Autorizações
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_viewatendimentoscompliance") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/compliance" className="itemMenu" active={pathname.indexOf("/compliance") !== -1} >
                            <FaFileContract /> Compliance de Terapia
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_exames") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/exames" className="itemMenu" active={pathname.indexOf("/exames") !== -1} >
                            <FaFileMedical /> Exames
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_atendimentos") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/farmacovigilancia" className="itemMenu" active={pathname.indexOf("/farmacovigilancia") !== -1} >
                            <FaFileMedical /> Farmacovigilancia
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_atendimentos") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/atendimentos-receptivo" className="itemMenu" active={pathname === "/atendimentos-receptivo" || pathname === "/atendimentos-receptivo/" } >
                            <FaHeadset /> Receptivos
                        </ListGroup.Item>
                    </ListGroup>
                )}
                {hasPerm('view_farmacovigilancia') && (
                    <ListGroup variant="flush">   
                        <ListGroup.Item 
                            action 
                            href="/reportes-farmaco"
                            className="itemMenu" 
                            active={pathname.indexOf("/reportes-farmaco") !== -1}
                        >
                            <FaFileMedicalAlt /> Reportes FV
                        </ListGroup.Item>      
                    </ListGroup>
                )}  
            </>
        )}

        {hasPerm("pode_gerar_relatorio") && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/relatorios" className="itemMenu" active={pathname === "/relatorios" || pathname === "/relatorios/"} >
                    <FaChartBar /> Relatórios
                </ListGroup.Item>
                <ListGroup.Item action href="/relatorios/duplicidades" className="itemMenu" active={pathname.indexOf("/relatorios/duplicidades") !== -1} >
                    <FaCheckDouble /> Relatório de Duplicidades
                </ListGroup.Item>
            </ListGroup>
        )}

            {/* GESTÃO FINANCEIRA ADMIN */}
            <div className="list-divider"> <p>Gestão Financeira</p> </div>

            {hasPerm("view_atendimentos") && (
                <>
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/creditosantecipacao" className="itemMenu" active={pathname.indexOf("/creditosantecipacao") !== -1} >
                            <FaMoneyBill /> Crédito Antecipação
                        </ListGroup.Item>
                    </ListGroup>

                    {hasPerm("view_agendamentos_despesas") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/despesas" className="itemMenu" active={pathname === "/despesas"} >
                            <FaDollarSign /> Despesas Agendamentos
                        </ListGroup.Item>
                    </ListGroup>
                    )}

                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/extratoservicos" className="itemMenu" active={pathname === "/extratoservicos"} >
                            <FaMoneyCheck /> Extrato Serviços
                        </ListGroup.Item>
                    </ListGroup>

                    {hasPerm("view_faturamentos") && (
                        <ListGroup variant="flush">
                            <ListGroup.Item action href="/faturamentos" className="itemMenu" active={pathname.indexOf("/faturamentos") !== -1} >
                                <FaCoins /> Faturamentos
                                {faturamentosPendentes > 0 && (
                                    <Badge pill bg="danger" className="ms-2">
                                        {faturamentosPendentes}
                                    </Badge>
                                )}
                            </ListGroup.Item>
                        </ListGroup>
                    )}
                </>
            )}

        {hasPerm("view_chamados") && dados_usuario.is_superuser && (
            <>
            <div className="list-divider">
                <p>Suporte</p>
            </div>
            <ListGroup variant="flush">
                <ListGroup.Item action href="/chamados" className="itemMenu" active={pathname.indexOf("/chamados") !== -1} >
                <TbTicket /> Chamados
                </ListGroup.Item>
                <ListGroup.Item action href="/notificacoes" className="itemMenu" active={pathname.indexOf("/notificacoes") !== -1}>
                    <FaBell /> Notificações
                </ListGroup.Item>
                <ListGroup.Item action href="/faq" className="itemMenu" active={pathname === "/faq" || (pathname.startsWith("/faq/") && pathname.indexOf("faq-areas") === -1)}>
                    <FaTeamspeak /> FAQ
                </ListGroup.Item>
            </ListGroup>
            </>
        )}

    {/* Gerenciamento de Programas e Pacientes ADMIN */}
    {(hasPerm('view_clientes') || hasPerm('view_programas') || hasPerm('view_gestores') || hasPerm('view_operadores') || hasPerm('view_prestadores') || hasPerm('view_planos') || hasPerm('view_carteiras') || hasPerm("view_exames_status")) && (
        <>
            <div className="list-divider"> <p> Gerenciamento de Programas e Pacientes</p> </div>

            <ListGroup variant="flush">   
                {hasPerm('view_carteiras') && (
                    <ListGroup.Item action href="/carteiras" className="itemMenu" active={pathname.indexOf('/carteiras') !== -1}>
                        <FaWallet /> Carteiras
                    </ListGroup.Item>
                )}
                {hasPerm("view_clientes") && (
                    <ListGroup.Item action href="/clientes" className="itemMenu" active={pathname.indexOf("/clientes") !== -1} >
                        <FaRegHandshake /> Clientes
                    </ListGroup.Item>
                    )}
                    
                {hasPerm("view_ultracarePspAtendimentosCompleto") && (
                    <ListGroup.Item action href="/codveeva" className="itemMenu" active={pathname.indexOf("/codveeva") !== -1} >
                        <FaEdit /> Cód Veeva
                    </ListGroup.Item>
                )}

                {hasPerm("view_exames_status") && (
                    <ListGroup.Item action href="/status-exames" className="itemMenu" active={pathname.indexOf("/status-exames") !== -1} >
                        <FaBookOpen /> Exames Status
                    </ListGroup.Item>
                )}

                {hasPerm("view_formularios") && (
                    <ListGroup.Item action href="/formularios" className="itemMenu" active={pathname.indexOf("/formularios") !== -1} >
                        <FaRegFileAlt /> Formulários
                    </ListGroup.Item>
                )}

                {hasPerm("view_gestores") && (
                    <ListGroup.Item action href="/gestores" className="itemMenu" active={pathname.indexOf("/gestores") !== -1} >
                        <FaUserMd /> Gestores
                    </ListGroup.Item>
                )}

                {hasPerm("view_prestadores") && (
                    <ListGroup.Item action href="/medicos" className="itemMenu" active={pathname.indexOf("/medicos") !== -1} >
                        <FaUserMd /> Médicos
                    </ListGroup.Item>
                )}

                {hasPerm("view_operadores") && (
                    <ListGroup.Item action href="/operadores" className="itemMenu" active={pathname.indexOf("/operadores") !== -1} >
                        <FaUserMd /> Navegadores
                    </ListGroup.Item>
                )}

                {hasPerm("view_planos") && (
                    <ListGroup.Item action href="/planos" className="itemMenu" active={pathname.indexOf("/planos") !== -1} >
                        <FaBoxes /> Planos
                    </ListGroup.Item>
                )}

                {hasPerm("view_programas") && (
                    <ListGroup.Item action href="/programas" className="itemMenu" active={pathname.indexOf("/programas") !== -1 && pathname.indexOf("/programas/faq-areas") === -1} >
                        <FaBox /> Programas
                    </ListGroup.Item>
                )}

                {hasPerm("view_prestadores") && (
                    <ListGroup.Item action href="/prestadores" className="itemMenu" active={pathname.indexOf("/prestadores") !== -1} >
                        <FaUserMd /> Provedores
                    </ListGroup.Item>
                )}

                {hasPerm("view_beneficiarios") && (
                    <ListGroup.Item action href="/pacientes" className="itemMenu" active={pathname.indexOf("/pacientes") !== -1} >
                        <FaUserInjured /> Relação Pacientes
                    </ListGroup.Item>
                )}

                {hasPerm("view_centros_referencia") && (
                    <ListGroup.Item action href="/centros-referencia" className="itemMenu" active={pathname.indexOf("/centros-referencia") !== -1} >
                        <FaBoxes/> Centros de Referencia
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
    )}

    {/* Configurações e Parametrizações ADMIN */}
    {(hasPerm('view_produtos') || hasPerm('view_termos') || hasPerm("view_termoplataforma") || hasPerm('view_servicos_procedimentos') || hasPerm('view_doencas') || hasPerm('view_modelos_mensagem') || hasPerm('view_emails') || hasPerm('view_formas_pagamento') || hasPerm('view_campos_personalizados') || hasPerm('view_campos_personalizados_atendimentos') || hasPerm('view_especialidades_medicas') || hasPerm('view_especialidade_multiprofissional') || hasPerm('view_categorias_multiprofissional') || hasPerm('view_farmacias') || hasPerm('view_tipos_programa')) && (
        <>
            <div className="list-divider"> <p>Configurações e Parametrizações</p> </div>
            
            <ListGroup variant="flush">
                {hasPerm('view_crms') && (
                    <ListGroup.Item action href="/base" className="itemMenu" active={pathname.indexOf('/base') !== -1}>
                        <FaEdit  /> Base CRM
                    </ListGroup.Item>
                )}

                {hasPerm('view_programas') && (
                    <ListGroup.Item action href="/programas/faq-areas" className="itemMenu" active={pathname.indexOf('/programas/faq-areas') !== -1}>
                        <FaTeamspeak /> Áreas de FAQ
                    </ListGroup.Item>
                )}

                {hasPerm('view_campos_personalizados_atendimentos') && (
                    <ListGroup.Item action href="/campos-personalizados-atendimentos" className="itemMenu" active={pathname === '/campos-personalizados-atendimentos'}>
                        <FaPenSquare /> Campos Personalizados Atendimentos
                    </ListGroup.Item>
                )}

                {hasPerm('view_campos_personalizados') && (
                    <ListGroup.Item action href="/campos-personalizados" className="itemMenu" active={pathname === '/campos-personalizados'}>
                        <FaPenSquare  /> Campos Personalizados Pacientes
                    </ListGroup.Item>
                )}

                {hasPerm('view_emails') && (
                    <ListGroup.Item action href="/emails-notificacao" className="itemMenu" active={pathname.indexOf('/emails-notificacao') !== -1}>
                        <FaEnvelope  /> Emails de Notificação
                    </ListGroup.Item>
                )}

                {hasPerm('view_formas_pagamento') && (
                    <ListGroup.Item action href="/formaspagamento" className="itemMenu" active={pathname.indexOf('/formaspagamento') !== -1}>
                        <FaCreditCard  /> Formas De Pagamento
                    </ListGroup.Item>
                )}

                {hasPerm('view_modelos_mensagem') && (
                    <ListGroup.Item action href="/modelos-mensagem" className="itemMenu" active={pathname.indexOf('/modelos-mensagem') !== -1}>
                        <FaRegIdCard  /> Modelos de Mensagem
                    </ListGroup.Item>
                )}

                {hasPerm('view_produtos') && (
                    <ListGroup.Item action href="/produtos" className="itemMenu" active={pathname.indexOf('/produtos') !== -1}>
                        <FaBriefcaseMedical  /> Produtos
                    </ListGroup.Item>
                )}

                {hasPerm('view_doencas') && (
                    <ListGroup.Item action href="/doencas" className="itemMenu" active={pathname.indexOf('/doencas') !== -1}>
                        <FaDisease  /> Protocolos de Tratamento
                    </ListGroup.Item>
                )}

                {hasPerm('view_servicos_procedimentos') && (
                    <ListGroup.Item action href="/servicos" className="itemMenu" active={pathname.indexOf('/servicos') !== -1}>
                        <FaStethoscope /> Serviços/Procedimentos
                    </ListGroup.Item>
                )}

                {hasPerm('view_termos') && (
                    <ListGroup.Item action 
                    href="/termos" 
                    className="itemMenu" 
                    active={
                            pathname === "/termos" ||
                            pathname.startsWith("/termos/")
                            }>
                        <FaEdit  /> Termos
                    </ListGroup.Item>
                )}

                {hasPerm("view_termoplataforma") && ( 
                                    <ListGroup.Item 
                                        action 
                                        href="/termos-plataforma" 
                                        className="itemMenu" 
                                        active={
                                                pathname === "/termos-plataforma" ||
                                                pathname.startsWith("/termos-plataforma/")
                                                }
                                    >
                                        <FaFileSignature /> Termos da Plataforma
                                    </ListGroup.Item>
                                )}

                {hasPerm('view_tipos_programa') && (
                    <ListGroup.Item action href="/tipos-programa" className="itemMenu" active={pathname.indexOf('/tipos-programa') !== -1}>
                        <FaEnvelope  /> Tipos de Programa
                    </ListGroup.Item>
                )}

                {dados_usuario.is_superuser && (
                    <ListGroup.Item action href="/formularios-eventos" className="itemMenu" active={pathname.indexOf('/formularios-eventos') !== -1}>
                        <FaFileSignature /> Formulários por Eventos
                    </ListGroup.Item>
                )}

                {hasPerm('view_pesquisas') && (
                    <></>
                /*
                <ListGroup.Item action href="/pesquisas" className="itemMenu" active={this.location.pathname.indexOf('/pesquisas') !== -1}>
                    <FaStar /> Pesquisas
                </ListGroup.Item>
                */
                )}
            </ListGroup>
        </>
    )}

    {hasPerm("view_chamados") && !dados_usuario.is_superuser && (
        <>
        <div className="list-divider">
            <p>Suporte</p>
        </div>
        <ListGroup variant="flush">
            <ListGroup.Item action href="/chamados" className="itemMenu" active={pathname.indexOf("/chamados") !== -1} >
                <TbTicket /> Chamados
            </ListGroup.Item>
            <ListGroup.Item action href="/notificacoes" className="itemMenu" active={pathname.indexOf("/notificacoes") !== -1}>
                <FaBell /> Notificações
            </ListGroup.Item>
        </ListGroup>
        </>
    )}

    {/* Especialidades e Profissionais ADMIN */}
    {(hasPerm("view_categorias_multiprofissional") || hasPerm("view_especialidades_medicas") || hasPerm("view_especialidade_multiprofissional") || hasPerm("view_farmacias") ) && (
        <>
            <div className="list-divider"> <p>Especialidades e Profissionais</p> </div>

            <ListGroup variant="flush">
                {hasPerm('view_categorias_multiprofissional') && (
                    <ListGroup.Item action href="/categorias-multiprofissional" className="itemMenu" active={pathname.indexOf('/categorias-multiprofissional') !== -1}>
                        <FaNotesMedical  /> Categorias Multiprofissional
                    </ListGroup.Item>
                )}

                {hasPerm('view_especialidades_medicas') && (
                    <ListGroup.Item action href="/especialidades-medicas" className="itemMenu" active={pathname.indexOf('/especialidades-medicas') !== -1}>
                        <FaMedkit  /> Especialidades Médicas
                    </ListGroup.Item>
                )}

                {hasPerm('view_especialidade_multiprofissional') && (
                    <ListGroup.Item action href="/especialidade-multiprofissional" className="itemMenu" active={pathname.indexOf('/especialidade-multiprofissional') !== -1}>
                        <FaRenren  /> Especialidades Multiprofissional
                    </ListGroup.Item>
                )}

                {hasPerm('view_farmacias') && (
                    <ListGroup.Item action href="/farmacias" className="itemMenu" active={pathname.indexOf('/farmacias') !== -1}>
                        <FaPills  /> Farmácias
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
    )}

    {/* Mensageria ADMIN */}
    {(hasPerm("view_atendimentos_hi_platform") || hasPerm("view_goto_connect") || dados_usuario.is_superuser) && (
        <>
            <div className="list-divider"> <p>Mensageria</p> </div>

            <ListGroup variant="flush">
                {hasPerm("view_atendimentos_hi_platform") && (
                    <ListGroup.Item action href="/atendimentos-hi-platform" className="itemMenu" active={pathname.indexOf("/atendimentos-hi-platform") !== -1} >
                        <FaUserAlt /> Atendimentos HiPlatform
                    </ListGroup.Item>
                )}
                {hasPerm("view_goto_connect") && (
                    <ListGroup.Item action href="/goto-connect" className="itemMenu" active={pathname.indexOf("/goto-connect") !== -1} >
                        <FaUserAlt /> GotoConnect
                    </ListGroup.Item>
                )}
                {dados_usuario.is_superuser && (
                    <ListGroup.Item action href="/visualizador-json-jivo" className="itemMenu" active={pathname.indexOf("/visualizador-json-jivo") !== -1} >
                        <FaFileImport /> Visualizador JSON Jivo
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
    )}

      {(hasPerm("view_pendentes") || dados_usuario.is_superuser) && (
        <>
          <div className="list-divider">
            <p>Arquivos</p>
          </div>
          <ListGroup variant="flush">
                <ListGroup.Item action href="/arquivos" className="itemMenu" active={pathname === "/arquivos" || pathname === "/arquivos/"} >
                    <FaFile /> Arquivos
                </ListGroup.Item>
                {dados_usuario.is_superuser && (
                    <ListGroup.Item action href="/importacao-arquivos" className="itemMenu" active={pathname.indexOf("/importacao-arquivos") !== -1}>
                        <FaFileImport /> Importação de Arquivos
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
      )}

      {/* Administração de Usuários ADMIN */}
      {(hasPerm("view_usuarios") || hasPerm("view_grupos") || hasPerm("view_logs")) && dados_usuario.is_superuser && (
        <>
          <div className="list-divider">
            <p>Administração de Usuários</p>
          </div>
          <ListGroup variant="flush">
                {hasPerm("add_grupos") && (
                    <ListGroup.Item action href="/grupos" className="itemMenu" active={pathname.indexOf("/grupos") !== -1} >
                        <FaUserFriends /> Grupos
                    </ListGroup.Item>
                )}

                {hasPerm("view_logs") && (
                    <ListGroup.Item action href="/logs" className="itemMenu" active={pathname.indexOf("/logs") !== -1} >
                        <FaRegEye /> Logs
                    </ListGroup.Item>
                )}

                {hasPerm("view_usuarios") && (
                    <ListGroup.Item action href="/usuarios" className="itemMenu" active={pathname.indexOf("/usuarios") !== -1} >
                        <FaUserAlt /> Usuários
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
      )}
    </>
  );
};

Menu.propTypes = {
  pathname: PropTypes.string.isRequired,
  faturamentosPendentes: PropTypes.number.isRequired
};

export default Menu;
